<style scoped>
.radius {
  border-radius: 0.25rem;
}
</style>
<script>
import { mapGetters } from 'vuex'
import { CONSTANT } from '../../utils/constant.js'

export default {
  name: 'CardPaymentInfo',
  data () {
    return {
      selectedCardIndex: null
    }
  },
  computed: {
    ...mapGetters(['merchantSavedCards'])
  },
  watch: {
    selectedCardIndex () {
      this.selectedCard()
    }
  },

  methods: {
    generateMaskedNumber (lastFourDigits) {
      const maskedDigits = '\u2022'.repeat(12)
      return maskedDigits + lastFourDigits
    },
    selectedCard () {
      if (this.selectedCardIndex !== null) {
        const selectedCard = this.merchantSavedCards[this.selectedCardIndex]
        this.$emit('onCardSelected', selectedCard)
      }
    },
    showUnbind (card) {
      return (card.bindingIds && card.bindingIds[localStorage.getItem(CONSTANT.APP_INSTANCE_KEY)])
    },

    requestUnbind (card) {
      this.$emit('onUnbindClick', card)
    }
  }
}
</script>
<template>
  <div
    id="card-payment-info"
    class="card-item ml-3">
    <template v-if="merchantSavedCards.length > 0">
      <div
        v-for="(card, key) in merchantSavedCards"
        :key="key"
        class="d-flex align-items-center justify-content-between border border-grey p-3 mb-3 radius"
      >
        <div>
          <label
            :for="'card-' + key"
            class="radio align-items-center d-flex mb-0 pb-0">
            <div>
              <input
                :id="'card-' + key"
                v-model="selectedCardIndex"
                :value="key"
                class="d-inline"
                type="radio"
              >
              <span class="check middle-align" />
            </div>
            <div class="d-flex gap-2">
              <div>
                <img
                  :src="card.scofMaskedCard.digitalCardData.artUri"
                  alt="No Image"
                  class="img-thumbnail card-logo"
                >
              </div>
              <div class="card-details">
                <div data-test="card-number">
                  {{ card.scofMaskedCard.digitalCardData.descriptorName }}
                </div>
                <div class="card-holder">
                  {{ generateMaskedNumber(card.scofMaskedCard.panLastFour) }}
                </div>
              </div>
            </div>
          </label>
        </div>
        <div v-if="showUnbind(card)">
          <a
            class="cursor-pointer"
            @click="requestUnbind(card)">
            <i
              class="fa fa-2x fa-unlink"
              aria-hidden="true"
              title="Unbind"/>
          </a>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        role="alert"
        class="alert alert-info">
        {{ $t("label.noSavedCard") }}
      </div>
    </template>
  </div>
</template>
